import { Timeframe } from '@ankr.com/chains-list';
import { useMemo, useState } from 'react';

import { useAuth } from 'modules/auth/hooks/useAuth';

import { TimeframeContext, TimeframeContextValue } from './context';

interface TimeframeProviderProps {
  children: React.ReactNode;
}

export const TimeframeProvider = ({ children }: TimeframeProviderProps) => {
  const { isLoggedIn } = useAuth();

  const [timeframe, setTimeframe] = useState(
    isLoggedIn ? Timeframe.Day : Timeframe.Month,
  );

  const value = useMemo(
    (): TimeframeContextValue => ({ timeframe, setTimeframe }),
    [timeframe],
  );

  return (
    <TimeframeContext.Provider value={value}>
      {children}
    </TimeframeContext.Provider>
  );
};
